var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 11C21.5 16.3762 16.8309 20.7904 11 20.7904C5.16908 20.7904 0.5 16.3762 0.5 11C0.5 5.62388 5.16908 1.20972 11 1.20972C16.8309 1.20972 21.5 5.62388 21.5 11Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.515 6.28972H8.685V10.4447H13.35V6.28972H14.505V15.7097H13.35V11.4497H8.685V15.7097H7.515V6.28972Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHBlack);
export default __webpack_public_path__ + "static/media/H_Black.42a61711303c37553dcf84c8f367634d.svg";
export { ForwardRef as ReactComponent };